import React, { useCallback, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";

import UploadTab from "./UploadTab";
import ConferenceTab from "./ConferenceTab";
import { makeBatchId } from "./helpers";

const ABA_IMPORTAR = "importar";
const ABA_CONFERENCIA = "conferencia";

const useStyles = makeStyles(() => ({
  content: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflow: "hidden",
  },
}));

/**
 * Importação de apólices por PDF, em duas abas.
 *
 * Importar e conferir eram duas páginas separadas até 20/09/2026. Na prática
 * é um fluxo só — quem sobe os PDFs confere logo em seguida — e a separação
 * só rendia navegação extra. O lote (`batchId`) vive aqui, e não dentro da
 * aba de importação, porque a conferência precisa do mesmo valor para abrir
 * filtrada no que acabou de ser enviado.
 *
 * A aba ativa fica na URL (`?aba=`) para o F5 não jogar o operador de volta
 * no dropzone e para /policy-documents poder redirecionar direto para cá.
 */
const PolicyDocumentImports = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const abaDaUrl = new URLSearchParams(location.search).get("aba");
  const aba = abaDaUrl === ABA_CONFERENCIA ? ABA_CONFERENCIA : ABA_IMPORTAR;

  // Um lote por sessão da tela, compartilhado pelas duas abas.
  const batchIdRef = useRef(makeBatchId());
  const [batchFilter, setBatchFilter] = useState("");

  const irPara = useCallback(
    (proximaAba, filtro = "") => {
      setBatchFilter(filtro);
      history.replace(
        proximaAba === ABA_CONFERENCIA
          ? `/policy-document-imports?aba=${ABA_CONFERENCIA}`
          : "/policy-document-imports"
      );
    },
    [history]
  );

  return (
    <MainContainer>
      <MainHeader>
        <Title>Importar apólices (PDF)</Title>
      </MainHeader>

      <Tabs
        value={aba}
        onChange={(event, value) => irPara(value)}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label="Importar" value={ABA_IMPORTAR} />
        <Tab label="Conferência" value={ABA_CONFERENCIA} />
      </Tabs>

      <div className={classes.content}>
        {aba === ABA_IMPORTAR ? (
          <UploadTab
            batchId={batchIdRef.current}
            onGoToConference={() => irPara(ABA_CONFERENCIA, batchIdRef.current)}
          />
        ) : (
          <ConferenceTab
            batchFilter={batchFilter}
            onClearBatchFilter={() => setBatchFilter("")}
          />
        )}
      </div>
    </MainContainer>
  );
};

export default PolicyDocumentImports;
